import { TableCell, TableRow, Typography } from '@mui/material'

type Props = {
  message: string
  colSpan: number
}

export const NoDataPlaceholder = ({ message, colSpan }: Props) => {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} align="center">
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </TableCell>
    </TableRow>
  )
}
